import { select,takeLatest, call, put } from "redux-saga/effects";
import { 
  MAP_GET_LOGISTIC_ROUTES,
  getCandidateRoutes,
  getMasterRoutes } from "../reducers/map/api";
import { 
  mapSetLogisticRoutes,
  mapSetCandidateRoutes,
  mapSetMasterRoutes,
  mapSetCandidatePolylines,
  mapSetMasterPolylines,
  mapSetMasterLegs,
  mapSetBounds,
  MAP_LOG,
  ADD_WAYPOINT,
  LOAD_MODIFIED_ROUTE_SUCCESS,
  MARKER_MOVE,
  DEL_MARKER,
  SET_WAYPOINTS,
  SET_MAP_LOADING,
  SELECT_MASTER_OR_CANDIDATE,
  MAP_SELECT_CANDIDATE,
  mapResetMap,
  MAP_RESET_MASTER_CANDIDATE,
  SET_USE_TOLL
} from "../reducers/map";

import axios from "axios";

import { formMasterRoute } from "../reducers/ui/mapForm";
import { parseWaypointPairs } from "../libs/geoLib";
import { buildRoutePolylines } from "../Components/RouteMaster/hereMigrationFilter";
import Configs from "../config/config";
const env = process.env.NODE_ENV;

// watcher saga: watches for actions dispatched to the store, starts worker saga
export default function* watcherSaga() {

  yield takeLatest(MAP_GET_LOGISTIC_ROUTES, logisticRoutesWorkerSaga);
  yield takeLatest(getCandidateRoutes, candidateRoutesWorkerSaga);
  yield takeLatest(getMasterRoutes, masterRoutesWorkerSaga);
  //yield takeLatest(getMasterRouteDetail, masterRouteDetailWorkerSaga);
  yield takeLatest(formMasterRoute,masterRouteDetailWorkerSaga);

  //----- Route Modifying
  yield takeLatest(ADD_WAYPOINT, loadNewPaths);
  yield takeLatest(MARKER_MOVE, loadNewPaths);
  yield takeLatest(DEL_MARKER, loadNewPaths);
  yield takeLatest(SET_WAYPOINTS, loadNewPaths);
  yield takeLatest(SET_USE_TOLL, loadNewPaths);
  
  
}

function fetchPaths(state) {
  let wps = state.waypoints.map(p => p.position.lat + "," + p.position.lng);
  if (wps.length < 2) return Promise.resolve(null);
  let origin = wps[0];
  let destination = wps[wps.length - 1];
  // Reroute through the editable pins themselves — state.waypoints is the single
  // source of truth (origin first, destination last, vias in between). Request a
  // single route (no alternatives) — this is a reroute, not a search.
  let intermediate = wps.slice(1, wps.length - 1);

  let body = {
    list: [{
      transportMode: "truck",
      origin: origin,
      destination: destination,
      waypoints: intermediate,
      returns: ["polyline", "summary", "tolls"],
      avoid: Number(state.use_toll) === 1 ? [] : ["tollway"],
      routingMode: "fast",
    }],
  };

  let headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Cache': "no-cache",
    'Authorization': Configs[env].AUTHORIZATION,
    'token': localStorage.getItem('token'),
  };

  return axios
    .post(Configs[env].BACKEND_HOST + "/getHereRouteCandidate", body, { headers: headers, timeout: 60000 })
    .then(resp => {
      if (resp.data.hasOwnProperty("errorList")) {
        alert(resp.data.errorList[0].errorMessage || resp.data.errorList);
        return null;
      }
      if (!resp.data.hasOwnProperty("list")) {
        alert(resp.data);
        return null;
      }
      return resp.data.list[0];
    })
    .catch(error => { return state.map ? state.map.legs : null; });
}

function* loadNewPaths() {
  yield put({ type: SET_MAP_LOADING, payload: true });

  const state = yield select();

  // yield put({ type: SET_MODIFYING_ROUTE_LOADING, payload: true });
  try {

    const modified_route = yield call(fetchPaths, state.map);

    if(modified_route !== null) {
      yield put({ type: MAP_LOG, payload: modified_route })

      let legs = setLegs(modified_route.Legs,false);
      let TollUsage = modified_route.TollUsage

      // Sync the editable pins from the route response so what's shown always
      // matches what Save persists (modified_route.waypoints). The vias come from
      // the response: echoed back as-is on a normal reroute (drag / add / delete /
      // generate), or auto-generated by distance when none were sent — e.g. the
      // Reset-to-default button clears the vias, so the backend regenerates them.
      // Origin/destination are the route endpoints; keep the current pin positions
      // (a reroute never moves them).
      let waypoints;
      const currentWps = state.map.waypoints;
      if (Array.isArray(currentWps) && currentWps.length >= 2) {
        const origin = currentWps[0];
        const destination = currentWps[currentWps.length - 1];
        const vias = parseWaypointPairs(modified_route.waypoints).map(
          ([lat, lng]) => ({ position: { lat: lat, lng: lng } })
        );
        waypoints = [origin, ...vias, destination];
      }

      yield put({ type: LOAD_MODIFIED_ROUTE_SUCCESS, payload: { legs : legs, modified_route : modified_route , TollUsage : TollUsage, waypoints : waypoints } });
    }
    yield put({ type: SET_MAP_LOADING, payload: false });

  } catch (error) {
    yield put({ type: SET_MAP_LOADING, payload: false });
    // yield put({ type: SET_MODIFYING_ROUTE_LOADING, payload: false });
  }
}

function fetchDataGet(params) {  
  let url = params.payload.url+'?'+paramsUrl(params.payload.filter);
  let callback = params.payload.callback;
  let headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Cache': "no-cache",
    'Authorization': Configs[env].AUTHORIZATION,
    'token':localStorage.getItem('token'),
  };
  return axios
    .get(url , { headers: headers , timeout: 60000})
    .then(resp => {
      if(resp.data.hasOwnProperty("errorList")){
        alert(resp.data.errorList[0].errorMessage)
        return null
      } else {
        if(!resp.data.hasOwnProperty("list")){
          alert(resp.data)
          return null
        } else {
          if(callback) callback(resp.data);
          return resp.data
        }
      }
    })
    .catch(error => {
      alert(error)
      return null;
    });
  // return fetch(url, {
  //   method: "GET",
  //   //mode : 'no-cors',
  //   headers: headers,
  // })
  // .then(resp=> {
  //   // Here you get the data to modify as you please

  //   return resp.json()
  // })
  // .then(data=>{

  //   if(callback) callback(data);
  //   return data;
  // })
  // .catch(function(error) {
  //   // If there is any error you will catch them here
  //   return error
  // }); 
}
function paramsUrl(data) {
  return Object.keys(data).map(key => `${key}=${encodeURIComponent(data[key])}`).join('&');
}
function fetchHerePost(params) {
  let headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Cache': "no-cache",
    'Authorization': Configs[env].AUTHORIZATION,
    'token': localStorage.getItem('token'),
  };
  return axios
    .post(Configs[env].BACKEND_HOST + "/getHereRouteCandidate", params.payload.body, { headers: headers, timeout: 60000 })
    .then(resp => {
      if (resp.data.hasOwnProperty("errorList")) {
        alert(resp.data.errorList[0].errorMessage || resp.data.errorList);
        return null;
      }
      if (!resp.data.hasOwnProperty("list")) {
        alert(resp.data);
        return null;
      }
      return resp.data;
    })
    .catch(error => { alert(error); return null; });
}
// worker saga: makes the api call when watcher saga sees the action
function* logisticRoutesWorkerSaga(action) {
  yield put({ type: MAP_LOG, payload: "before loading" })
  yield put({ type: SET_MAP_LOADING, payload: true })
  yield put({ type: mapResetMap, payload: true })
  yield put({ type: MAP_RESET_MASTER_CANDIDATE, payload: true })
  yield put({ type: MAP_LOG, payload: "after loading" })

  try {

    yield select();
    const response = yield call(fetchDataGet, action);

    if(response !== null) {

      yield put({ type: mapSetLogisticRoutes, payload:response.list });
    }
    yield put({ type: SET_MAP_LOADING, payload: false });

  } catch (error) {
    // dispatch a failure action to the store with the error
    //yield put({ type: mapAction.authLoginError, error });

    yield put({ type: SET_MAP_LOADING, payload: false });

  }
}

// worker saga: makes the api call when watcher saga sees the action
function* candidateRoutesWorkerSaga(action) {
  try {

    yield put({ type: SET_MAP_LOADING, payload: true });
    yield select();
    const response = yield call(fetchHerePost, action);
    if(response !== null) {


      //Set polyline
      let polylines = setPolylines(response.list,false);


      let bounds = setBounds(response.list);

      yield put({ type: mapSetCandidateRoutes, payload:response.list });
      yield put({ type: mapSetCandidatePolylines, payload:polylines });
      yield put({ type: mapSetBounds, payload:bounds });

      yield put({ type: SELECT_MASTER_OR_CANDIDATE, payload:2 });
    }

    yield put({ type: SET_MAP_LOADING, payload: false });
  } catch (error) {
    // dispatch a failure action to the store with the error
    //yield put({ type: mapAction.authLoginError, error });


    yield put({ type: SET_MAP_LOADING, payload: false });

  }
}

// worker saga: makes the api call when watcher saga sees the action
function* masterRoutesWorkerSaga(action) {
  try {
    yield put({ type: SET_MAP_LOADING, payload: true });

    const prevState = yield select();
    const response = yield call(fetchDataGet, action);


    if(response !== null) {

      //Set polyline
      let polylines = setPolylines(response.list,false);


      let bounds = setBounds(response.list);


      yield put({ type: mapSetMasterRoutes, payload:response.list });
      yield put({ type: mapSetMasterPolylines, payload:polylines });
      yield put({ type: mapSetBounds, payload:bounds });

      yield put({ type: SELECT_MASTER_OR_CANDIDATE, payload:1 });

      // Reloading the list (e.g. after returning from edit) runs RESET_MAP, which
      // clears candidate_waypoints. If a route is still selected, re-select it so
      // its waypoint dots are restored from the freshly loaded master_routes.
      let selecting = prevState.map.candidate_selecting;
      if (selecting !== -1 && selecting != null) {
        yield put({ type: MAP_SELECT_CANDIDATE, payload: selecting });
      }
    }
    yield put({ type: SET_MAP_LOADING, payload: false });

  } catch (error) {
    // dispatch a failure action to the store with the error
    //yield put({ type: mapAction.authLoginError, error });
    yield put({ type: SET_MAP_LOADING, payload: false });

    

  }
}
// for Add/Edit Waypoints
function* masterRouteDetailWorkerSaga(action) {
  try {
    yield put({ type: SET_MAP_LOADING, payload: true });

    const state = yield select();
    //const response = yield call(fetchDataGet, action);
    
    let response = state.mapForm.masterRouteForm;
    let legs = setLegs(response.routes.Legs,false);

    // Build the editable pins from origin + the saved vias + destination, so a
    // stored route's via-points load as numbered, draggable waypoints (single
    // source of truth). Origin/destination come from the first leg's start and
    // the last leg's end; the intermediate vias come from routes.waypoints
    // (nested [[lat, lng], ...]; parseWaypointPairs also accepts legacy flat).
    let waypoints = []
    waypoints.push({ position : { lat : legs[0].path[0].lat() , lng : legs[0].path[0].lng() } })

    parseWaypointPairs(response.routes.waypoints).forEach(([lat, lng]) => {
      waypoints.push({ position : { lat : lat , lng : lng } });
    });

    let last_leg_idx = legs.length - 1
    let last_path_idx = legs[last_leg_idx].path.length - 1

    waypoints.push(
      { position :
        {
            lat : legs[last_leg_idx].path[last_path_idx].lat() ,
            lng : legs[last_leg_idx].path[last_path_idx].lng()
          }
      })


    // yield put({ type: mapSetCandidateRoutes, payload: {} });
    // yield put({ type: mapSetCandidatePolylines, payload: {} });

    // HERE migration tooling (temporary -- drop alongside the backend
    // hereMigration* columns once the migration project is finished):
    // hereMigrationProblematicWaypoints holds 0-indexed positions into
    // routes.waypoints (the via array) bounding the still-flagged leg(s) on
    // a 'validation-required' row. The `waypoints` array built above has
    // origin prepended at index 0, so a via index there is this array's
    // index + 1.
    let problematicWaypoints = (response.hereMigrationProblematicWaypoints || []).map(
      viaIndex => viaIndex + 1
    );

    yield put({ type: mapSetMasterLegs, payload: { legs : legs, waypoints : waypoints, problematicWaypoints : problematicWaypoints } });

    let bounds = setBoundsWaypoints(response.routes.Legs)
  

    yield put({ type: mapSetMasterPolylines, payload:waypoints });
    yield put({ type: mapSetBounds, payload:bounds });

    yield put({ type: SET_MAP_LOADING, payload: false });

  } catch (error) {
    // dispatch a failure action to the store with the error
    //yield put({ type: mapAction.authLoginError, error });
    yield put({ type: SET_MAP_LOADING, payload: false });


  }
}

/////// POLYLINE /////////
function setPolylines(data,editable){

  let candidatePolylineList = [];
  if(data){
      let decodePath = window.google.maps.geometry.encoding.decodePath;
      data.forEach((item, i) => {
        // buildRoutePolylines returns 1 polyline (today's real backend, no
        // bk_routes) or 2 (current + backup "old" line, once the backend
        // starts sending bk_routes) — flatten them all into one list.
        candidatePolylineList = candidatePolylineList.concat(buildRoutePolylines(item, decodePath));
      });
      return candidatePolylineList;
  }
}

function setLegs(data,clickable){

  let candidatePolylineList = [];
  let polyline = {};
  if(data){
      data.forEach((item, i) => {
        //if(item.type=='polyline'){
          var decodePath = window.google.maps.geometry.encoding.decodePath(decodeURIComponent(item.Route));
          var paths = [];
          decodePath.forEach(function(p) {
            paths.push({ lat: p.lat(), lng: p.lng()} );
          });
          polyline = {
            id : item.Seq,
            path : decodePath,
            info : {
              name : item.Seq,
              description : '',
              logisticsPoint : '' ,
              clickable : clickable
            }
          };
          //candidatePolylineList.push(polyline);
          candidatePolylineList.push(polyline);
        //}
      });
      return candidatePolylineList;
  }
}

function setBounds(data){
  let bounds = [];
  if(data){
      data.forEach((item, i) => {
          if(item.routes) {
            item = item.routes;
          }
          var decodePath = window.google.maps.geometry.encoding.decodePath(decodeURIComponent(item.MergeRoute ? item.MergeRoute : item.Route));

          decodePath.forEach(function(p) {
            bounds.push({ lat: p.lat(), lng: p.lng()} );
          });
      });
  }
  return bounds;
}


function setBoundsWaypoints(Legs){
  let bounds = [];
  if(Legs){
      Legs.forEach((item, i) => {
          var decodePath = window.google.maps.geometry.encoding.decodePath(decodeURIComponent(item.Route));

          decodePath.forEach(function(p) {
            bounds.push({ lat: p.lat(), lng: p.lng()} );
          });
      });
  }
  return bounds;
}

